__webpack_require__.p = "//kengyn.github.io/memory-card/";